<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="mosquito-edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ form.modal.title }}</h4>
        </div>
        <div class="modal-body">
          <form
            @submit.prevent="form.onSubmit({ updateList: false })"
            @keydown="form.errors.clear($event.target.id)"
          >
            <input type="hidden" name="id" v-model="form.data.id" />
            <input
              type="hidden"
              name="adultSurveillanceId"
              v-model="form.data.adultSurveillancesId"
            />

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('mosquitoSpecy') }"
            >
              <label class="control-label">Mosquito Species</label>
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="form.data.mosquitoSpeciesId"
                >
                  <option></option>
                  <option
                    v-for="item in mosquitoes"
                    v-bind:value="item.id"
                    :key="item.id"
                    >{{ item.attributes.name }}</option
                  >
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('mosquitoSpecy')"
                v-text="form.errors.get('mosquitoSpecy')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('mosquitoSpecy') }"
            >
              <label class="control-label">Mosquito Gender</label>
              <div class="form-group gender-container">
                <div class="checkbox">
                  <label>
                    <input type="radio" value="f" v-model="form.data.sex" />
                    Female
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="radio" value="m" v-model="form.data.sex" />
                    Male
                  </label>
                </div>
              </div>

              <span
                class="help-block"
                v-if="form.errors.has('mosquitoSpecy')"
                v-text="form.errors.get('mosquitoSpecy')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('mosquitoCount') }"
            >
              <label class="control-label">Mosquito Count</label>
              <input
                type="text"
                class="form-control"
                id="mosquitoCount"
                v-model="form.data.mosquitoCount"
              />
              <span
                class="help-block"
                v-if="form.errors.has('mosquitoCount')"
                v-text="form.errors.get('mosquitoCount')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('sampleNumber') }"
            >
              <label class="control-label">Sample No.</label>
              <input
                type="text"
                class="form-control"
                id="sampleNumber"
                v-model="form.data.sampleNumber"
              />
              <span
                class="help-block"
                v-if="form.errors.has('sampleNumber')"
                v-text="form.errors.get('sampleNumber')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('cdcSampleNumber') }"
            >
              <label class="control-label">CDC Sample No.</label>
              <input
                type="text"
                class="form-control"
                id="cdcSampleNumber"
                v-model="form.data.cdcSampleNumber"
              />
              <span
                class="help-block"
                v-if="form.errors.has('cdcSampleNumber')"
                v-text="form.errors.get('cdcSampleNumber')"
              ></span>
            </div>

            <div
              class="checkbox"
              :class="{ 'has-error': form.errors.has('irregularLabResults') }"
            >
              <label>
                <input
                  type="checkbox"
                  id="irregularLabResults"
                  v-model="form.data.irregularLabResults"
                />
                High Trap Count
              </label>
              <span
                class="help-block"
                v-if="form.errors.has('irregularLabResults')"
                v-text="form.errors.get('irregularLabResults')"
              ></span>
            </div>

            <loading-button
              :loading="form.loading"
              class="btn btn-primary"
              :disabled="form.errors.any()"
              >Save</loading-button
            >
            <button type="button" class="btn btn-default" data-dismiss="modal">
              cancel
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import LoadingButton from '@/components/loading-button';
import DatePicker from '@/components/date-picker';

export default {
  name: 'adult-surveillance-mosquito-form',

  props: ['form'],

  components: {
    LoadingButton,
    DatePicker,
  },

  methods: {},

  computed: {
    mosquitoes() {
      return this.$store.getters.mosquitoSpecies;
    },
  },
};
</script>

<style lang="scss" scoped>
.gender-container {
  margin: -1.5rem 0 0 -1.75rem;
}
</style>
